import { html, css } from 'lit'
import { TableBase } from 'shared/tables/table-base.component'


class backgroundJobsTable extends TableBase {
    static properties = {
        allowed: {},
        data: { type: Array },
        integrationId: { type: Number },
        organization: false
    };

    static styles = [
        TableBase.styles,
        css`

    .action svg {
      height: 27px;
      width: 27px;
      padding: 1px;
      margin-right: 10px;
    }
    .action svg path {
      transition: fill .2s;
      fill: white;
    }
    .action svg circle {
      transition: fill .2s;
      stroke: white;
    }

    .action:hover {
      color: #d6d9e0;
    }
    .action:hover svg path {
      fill: #d6d9e0
    }
    .action:hover svg circle {
      stroke: #d6d9e0
    }
    .danger {
      color: #D75762;
    }

    .c-column span{
      display: inline-flex;
    }

    .fa{
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      -webkit-font-smoothing: antialiased;
      display: inline-block;
      font-style: normal;
      font-variant: normal;
      text-rendering: auto;
      line-height: 1;
      cursor: pointer;
    }
    .fa-exclamation-triangle{
      margin-left: 5px;
      margin-top: 3px;
    }
    .fa-exclamation-triangle:before {
        content: "\\f071";
    }
    `,
    ];

    constructor() {
        super()
        this.updatingModal = false;
        this.escapeNotInit = true;
        this.dataName = 'processes';
        this.paginationEnabled = false;
        this.columns = [
            { key: 'id', title: 'Id' },
            { key: 'status', title: 'Status' },
            { key: 'completedAt', title: 'Completed At' },
            { key: 'actions', title: '', display: 'always-right' },
        ]
    }

    connectedCallback() {
        super.connectedCallback()
        this.render();
    }

    cellValue(colKey, item) {
        let value = html``;

        if (colKey === 'id') {
            value = item.id
        } else if (colKey === 'status') {
            let error = item.has_errors
            let status = item.status
            if (status == 'completed' && error) {
                status = 'warning'
            }
            value = []
            value.push(html`
                ${status.toUpperCase()}`);
            if (item.has_errors) {
                value.push(html`<span class="danger fa fa-exclamation-triangle"></span>`)
            }
            return value
        } else if (colKey === 'completedAt') {
            value = Util.formatDateTime(item.completed_at);
        } else if (colKey === 'actions') {
            if (this.allowed.split(',').includes('edit') && item.status != 'canceled' && item.status != 'completed') {
                let url = this.organization ? `/organization/integrations/${item.integration_id}/cancel_job` : `/integrations/${item.integration_id}/cancel_job`
                value = [
                    {
                        title: 'Cancel process',
                        url: url + "?job_id=" + item.id,
                        httpMethod: 'post',
                        remote: false,
                        protect: 'destroy'
                    }
                ]
            }
        }
        return value
    }


    formatInfo(info, type) {
        let html = '';
        if (info && info.length > 0) {
            for (const inf of info) {
                let batch = false
                let batchHandled = false
                if (inf.id_represents == 'batch') {
                    batch = true;
                }
                for (const msg of inf.log_messages) {
                    let cssClass = 'info'
                    if (msg.message_level == 'error') {
                        cssClass = 'error'
                        if (type != 'info') {
                            if (batch && !batchHandled) {
                                html += `<div class="batch">BATCH: ${inf.item_id}`
                                batchHandled = true
                            }
                            html += `<span class=${cssClass}>${moment(msg.created_at).format('MM/DD h:mm:ss a')} ${msg.message_level}: ${msg.message}</span>`
                        }
                    } else {
                        if (type != 'errors') {
                            if (batch && !batchHandled) {
                                html += `<div class="batch">BATCH: ${inf.item_id}`
                                batchHandled = true
                            }
                            html += `<span class=${cssClass}>${moment(msg.created_at).format('MM/DD h:mm:ss a')} ${msg.message_level}: ${msg.message}</span>`
                        }
                    }
                }
                if (batchHandled) {
                    html += `</div>`
                }
            }
            html += '</div>'
        } else {
            html += '';
        }
        return html;
    }

    openModal(job) {
        let thiz = this;
        let warn = '';
        let error = job.has_errors
        let status = job.status
        if (status == 'completed' && error) {
            status = 'warning'
        }
        if (error) {
            warn = `<span class="danger fa fa-exclamation-triangle"></span>`
        }
        let html = `
        <div class="information">
          <div class="detailColumn left">
            <div class="info">
              <div class="label">Name</div>
              <div class="value">${job.name}</div>
            </div>
            <div class="info">
              <div class="label">Status</div>
              <div class="value">${status.toUpperCase()}&nbsp;&nbsp;${warn}</div>
            </div>
            <div class="info">
              <div class="label">Started</div>
              <div class="value">${job.started_at ? Util.formatDateTime(job.started_at) : '-'}</div>
            </div>
            <div class="info">
              <div class="label">Job Class</div>
              <div class="value">${job.job_class}</div>
            </div>
            <div class="info">
              <div class="label">State</div>
              <div class="value">${job.state ? JSON.stringify(job.state) : '-'}</div>
            </div>
          </div>
          <div class="detailColumn middle">
          <div class="info info-right">
              <div class="label">Job ID</div>
              <div class="value">${job.job_id}</div>
            </div>
            <div class="info">
              <div class="label">Percent Complete</div>
              <div class="value">${job.percent_complete ? job.percent_complete : '0'} %</div>
            </div>
            <div class="info">
              <div class="label">Completed</div>
              <div class="value">${job.completed_at ? Util.formatDateTime(job.completed_at) : '-'}</div>
            </div>
            <div class="info">
              <div class="label">Job Queue</div>
              <div class="value">${job.job_queue ? job.job_queue : '-'}</div>
            </div>
          </div>
          <div class="detailColumn right">
            <div class="info info-right">
                <div class="refresh-modal"></div>
            </div>
            <div class="info info-right">
              <div class="label">&nbsp;</div>
              <div class="value no-borders">&nbsp;</div>
            </div>
            <div class="info info-right">
              <div class="label">Duration</div>
              <div class="value">${job.completed_at ? Util.formatDuration(job.started_at, job.completed_at) : '-'}</div>
            </div>
          </div>
        </div>
        <mss-button slot="button" value="info">Info</mss-button>
        <mss-button slot="button" value="errors">Errors</mss-button>
        <mss-button slot="button" class="primary" value="all">All</mss-button>
        <div class="integrationLogs">
          ${this.formatInfo(job.log_entries, 'all')}
        </div>
      `;
        DialogModal.render({
            title: 'Background Job Details',
            message: html,
            class: 'background-details',
        });
        $('mss-button').click(({ thiz: thiz, job: job }), this.filterLogs)

        $('.refresh-modal').click(({ thiz: thiz, job: job }), this.refreshModal)
    }


    filterLogs(e) {
        let value = e.target.getAttribute('value')
        $(e.target).siblings('mss-button').removeClass('primary')
        $(e.target).addClass('primary')
        $('.integrationLogs').html(e.data.thiz.formatInfo(e.data.job.log_entries, value))
    }

    updated() {
        let rows = this.renderRoot.querySelectorAll('.c-row')
        let thiz = this
        for (const row of rows) {
            row.addEventListener('click', this.rowClick)
            row.backgroundJobsTable = thiz;
        }
    }

    rowClick(event, options) {
        if (event.target.closest('[data-type="actions"]')) {
            return;
        }
        event.preventDefault();
        let id = this.dataset['id']
        this.backgroundJobsTable.getData(id);
    }

    refreshModal = function (e) {
        DialogModal.close();
        e.data.thiz.getData(e.data.job.id)
    }

    getData(id) {
        if (!id || this.updatingModal) return;
        this.updatingModal = true;
        let url = this.organization ? `/organization/integrations/${this.integrationId}/background_job/${id}.json` : `/integrations/${this.integrationId}/background_job/${id}.json`

        fetch(url)
            .then(res => res.json())
            .then(job => {
                this.updatingModal = false;
                if (job) {
                    this.openModal(job);
                    if (this.escapeNotInit) {
                        $(document).on('keydown', function (event) {
                            if (event.key == "Escape") {
                                DialogModal.close();
                            }
                        });
                        this.escapeNotInit = false;
                    }
                    this.render();
                }
            })
            .catch(err => {
                console.error('Error fetching job:', err);
                this.updatingModal = false;
            });
        }
}

customElements.define('background-jobs-table', backgroundJobsTable)
